import { trunkFloat } from '@/helpers'
import * as types from '@/store/mutation-types'

const getInitialState = () => ({
  // not implemented yet
  groups: {},
  // not implemented yet
  applied: [],
  simples: [],
  price: {
    min: null,
    max: null
  },
  purchasesPrice:{
    min: null,
    max: null
  },
  salesPrice:{
    min: null,
    max: null
  },
  location: {
    lat: null,
    lon: null,
    city: null
  },
  purchasesSimples: [],

  for_sale: null
})

const state = getInitialState()

const getters = {
  location: (state) => ({
    ...state.location
  }),

  reducedSimpleFilters: (state) => {
    return {
      ...(Array.isArray(state.simples) ? state.simples : []).reduce((obj, {key, val}) => {
        key = key.split('_')
        if (key.length > 1) key.pop()
        key = key.join('_')
        val = val.toString()
        return {...obj, [key]: val.split('_').length > 1 ? val.split('_')[1] : val}
      }, {})
    }
  }
}

const actions = {
  resetState: ({commit}) => {
    commit(types.RESET_FILTERS_STATE)
    return Promise.resolve()
  },

  setGroups: ({commit}, groups) => { commit(types.SET_FILTERS_GROUP, groups) },

  setApplied: ({commit}, filters) => { commit(types.SET_FILTERS_APPLIED, filters) },

  addSimple: ({commit}, filter) => { commit(types.ADD_SIMPLE_FILTER, filter) },

  removeSimple: ({commit}, filter) => { commit(types.REMOVE_SIMPLE_FILTER, filter) },

  setSimples: ({commit}, filters) => { commit(types.SET_SIMPLE_FILTERS, filters) },

  setPurchasesSimples: ({commit}, filters) => { commit(types.SET_PURCHASES_SIMPLE_FILTERS, filters) },

  setSalesSimples: ({commit}, filters) => { commit(types.SET_SALES_SIMPLE_FILTERS, filters) },

  setPrice: ({commit}, filter) => { commit(types.SET_FILTER_PRICE, filter) },

  setPurchasesPrice: ({commit}, filter) => { commit(types.SET_FILTER_PURCHASES_PRICE, filter) },

  setSalesPrice: ({commit}, filter) => { commit(types.SET_FILTER_SALES_PRICE, filter) },

  setLocation: ({commit}, location) => new Promise((resolve, reject) => {
    commit(types.SET_FILTERS_LOCATION, location)
    resolve()
  })
}

const mutations = {
  [types.RESET_FILTERS_STATE] (state) {
    Object.assign(state, getInitialState())
  },

  [types.SET_FILTERS_GROUP] (state, groups) {
    state.groups = groups
  },

  [types.SET_FILTERS_APPLIED] (state, filters) {
    state.applied = filters
  },

  [types.ADD_SIMPLE_FILTER] (state, filter) {
    state.simples = [...state.simples, filter]
  },

  [types.REMOVE_SIMPLE_FILTER] (state, filter) {
    state.simples = state.simples.filter(f => f.key !== filter.key)
  },

  [types.SET_SIMPLE_FILTERS] (state, filters) {
    state.simples = filters || []
  },

  [types.SET_PURCHASES_SIMPLE_FILTERS] (state, filters) {
    state.purchasesSimples = filters || []
  },

  [types.SET_SALES_SIMPLE_FILTERS] (state, filters) {
    state.salesSimples = filters || []
  },

  [types.SET_FILTER_PRICE] (state, filter) {
    state.price = {
      min: parseInt(filter.min) || null,
      max: parseInt(filter.max) || null
    }
  },

  [types.SET_FILTER_PURCHASES_PRICE] (state, filter) {
    state.price = {
      min: parseInt(filter.min) || null,
      max: parseInt(filter.max) || null
    }
  },

  [types.SET_FILTER_SALES_PRICE] (state, filter) {
    state.salesPrice = {
      min: parseInt(filter.min) || null,
      max: parseInt(filter.max) || null
    }
  },

  [types.SET_FILTERS_LOCATION] (state, location) {
    state.location = {
      lat: trunkFloat(parseFloat(location.lat)),
      lon: trunkFloat(parseFloat(location.lon)),
      city: location.city
    }
  },

}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/filters.js